import CircularProgress from '@mui/material/CircularProgress'
import { createSelector } from '@reduxjs/toolkit'
import { CONSTS } from 'config/objectConst'
import { activityHooks } from 'features/activity'
import { notificationUtils } from 'features/notifications'
import { workspaceApi } from 'features/workspace'
import { useState } from 'react'
import { useAppSelector, useSwitcher } from 'shared/hooks'
import { CustomSelect } from 'shared/ui'

import { appSelectors } from '../../../redux/reducers/app'
import store from '../../../redux/store'
import css from './SelectTimeZone.module.scss'

export interface Option {
	label: string
	value: string
}

const selectCurrentOption = createSelector(
	appSelectors.timezoneOffset,
	offset =>
		CONSTS.TIME_ZONES.find(item => +item.value === offset) ??
		CONSTS.TIME_ZONES[0]
)

export function SelectTimeZone() {
	const openSwitcher = useSwitcher(false)

	const [value, setValue] = useState(getInitial)

	const refreshAccessToken = useAppSelector(appSelectors.refreshAccessToken)

	const [send, { isLoading }] = workspaceApi.useTimezoneOffsetMutation()
	const refetchActivity = activityHooks.useRefetch()

	const handleChangeTimeZone = async (option: null | Option) => {
		if (option === null || option === value || isLoading) {
			return
		}

		const oldValue = value
		const timezoneOffset = Number(option.value)
		setValue(option)

		try {
			await send(timezoneOffset).unwrap()

			notificationUtils.snackById('3.14')
			Promise.all([refreshAccessToken(), refetchActivity()])
		} catch (error) {
			setValue(oldValue)
		}
	}

	return (
		<div className={css.root}>
			<CustomSelect
				isDisabled={isLoading}
				isMulti={false}
				isSearchable={false}
				onChange={handleChangeTimeZone}
				onMenuClose={openSwitcher.off}
				onMenuOpen={openSwitcher.on}
				options={CONSTS.TIME_ZONES}
				value={value}
			/>

			{isLoading && (
				<CircularProgress
					classes={{ colorPrimary: 'material-loader' }}
					className={css.loader}
					color='primary'
					size={'1.13rem'}
				/>
			)}
		</div>
	)
}

function getInitial(): Option {
	const state = store.getState()
	return selectCurrentOption(state)
}
